import React from 'react'
import { Container } from '@/Components/Container'

export default function AdminLayout({ children }) {
  return (
    <div className="relative z-0 w-full m-0 overflow-x-hidden bg-background">
        <Container size={"4xl:max-w-screen-3xl"} padding={"px-4 lg:px-16 4xl:pl-32"} className={"4xl:mx-0"}>
        <div className="py-4 mt-8">{children}</div>
      </Container>
    </div>
  )
}
